import { useCallback } from 'react';
import { useTableState } from 'src/components/DataTable/components/DataTableProvider/hooks/useTableState';
import { useTableAdapter } from 'src/components/DataTable/components/DataTableProvider/hooks/useTableAdapter';
import {
  TableAdapterHook,
  TableContextValue,
  TableState,
} from 'src/components/DataTable/types/DataTable';

export function useDataTable<TData, TFilters>(
  adapter: TableAdapterHook<TData, TFilters>,
  initialState?: Partial<TableState<TFilters>>
): TableContextValue<TData, TFilters> {
  const {
    tableState,
    initialState: storedInitialState,
    setQuery,
    setPage,
    resetState,
  } = useTableState(initialState);

  const {
    data,
    total,
    status,
    error,
    isLoading,
    isEmpty,
    isError,
    hasSearchQuery,
    fetch,
  } = useTableAdapter(adapter, tableState);

  const reset = useCallback((): void => {
    resetState();
  }, [resetState]);

  const refresh = useCallback((): Promise<void> => {
    return fetch(tableState);
  }, [fetch, tableState]);

  return {
    tableState,
    initialState: storedInitialState,
    data,
    total,
    status,
    error,
    isLoading,
    isEmpty,
    isError,
    hasSearchQuery,
    setQuery,
    setPage,
    reset,
    refresh,
  };
}
